import TINTGCaseStudy from "./TINTGCaseStudy";

export { Page }

function Page() {
  return <TINTGCaseStudy />;
}
